import React from 'react';
import { getTranslations } from '@/i18n/translations';
import './WelcomeScreen.css';

const WelcomeScreen = ({
  language,
  onLanguageChange,
  onStartChat,
  onClose,
  isWidget = false,
}) => {
  const t = getTranslations(language);
  const isRTL = language === 'ar';

  return (
    <div
      className={`welcome-screen ${isWidget ? 'welcome-screen-widget' : 'welcome-screen-app'}`}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="welcome-screen-background">
        <div className="welcome-screen-header" dir="ltr">
          {isWidget ? (
            <button
              type="button"
              className="welcome-screen-close"
              onClick={onClose}
              aria-label={t.closeChat}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          ) : (
            <span />
          )}
          <img
            src="/assets/header-logo.svg"
            alt={t.logoAlt}
            className="welcome-screen-logo"
          />
        </div>

        <div className="welcome-screen-card">
          <p className="welcome-screen-text" dir={isRTL ? 'rtl' : 'ltr'}>
            {t.welcome1}
          </p>
          <p className="welcome-screen-text" dir={isRTL ? 'rtl' : 'ltr'}>
            {t.welcome2}
          </p>
          <p className="welcome-screen-text" dir={isRTL ? 'rtl' : 'ltr'}>
            {t.welcome3}
          </p>

          <select
            className="welcome-screen-language"
            value={language}
            onChange={(e) => onLanguageChange(e.target.value)}
            aria-label={t.chooseLang}
          >
            <option value="ar">العربية (Arabic)</option>
            <option value="en">English (الإنجليزية)</option>
          </select>

          <button
            type="button"
            className="welcome-screen-start"
            onClick={onStartChat}
          >
            {t.startButton}
          </button>
        </div>

        <div className="welcome-screen-beta">{t.beta}</div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
